/* @flow */
/* eslint-env es6,browser */

import _idpbase from './idpbase';
import { IDP_LIVERAMP } from './idpconstants';
import { getCookie, setCookie } from '../utils/cookie';
import getCVars from '../utils/gputils';
import { isFetchSupported, fetchJSON } from '../utils/fetch';

const LIVERAMP_CACHE_KEY = '_lr_env';

/**
 * Reference
 * https://docs.authenticated-traffic-solution.com/reference/retrieving-envelopes
 * https://docs.authenticated-traffic-solution.com/docs/api-only-implementation
 */

/**
 * @description Implement functionality generating LiveRamp ID
 * @module liverampid
 */
class _liverampidp extends _idpbase {
  _idRequested: boolean;

  constructor(name: string) {
    super(name);
    this._idRequested = false; // to avoid requesting repeatedly for adblock scenario
  }

  _getEnvelope(): void {
    // do we have valid config to send request
    if (
      this._url.length === 0 ||
      this._pid.length === 0 ||
      !isFetchSupported()
    ) {
      return;
    }
    // get customer's hash values
    const cvars = getCVars();
    const {
      _uh: sha1Email = '',
      _uh4: md5Email = '',
      _uh6: sha256Email = ''
    } = cvars;
    // all email hashes should be sent with it=4&iv=<value>
    const xtraparam = [sha1Email, md5Email, sha256Email]
      .filter((v: string) => v.length > 0)
      .map((v: string) => `it=4&iv=${v}`)
      .join('&');
    /* if (xtraparam.length === 0) {
      return;
    } */
    const URL = `${this._url}?pid=${this._pid}&${xtraparam}`;
    // eslint-disable-next-line promise/catch-or-return
    fetchJSON(
      URL,
      { data: {}, logPrefix: IDP_LIVERAMP, timeout: 2000 },
      { credentials: 'include', mode: 'cors' }
    ).then((res: LREnvelope = {}) => {
      this._cachedID = res.envelope || '';
      if (!this._cachedID.length) {
        // nothing to store here
        return this._cachedID;
      }

      // store it in cookie for future
      setCookie(
        LIVERAMP_CACHE_KEY,
        this._cachedID,
        this._doc,
        this._nExpireDays * 24 * 60 * 60
      );
      return this._cachedID;
    });
  }

  _refreshID(): string {
    if (this._idRequested || this._cachedID.length) {
      return this._cachedID;
    }
    this._idRequested = true;

    // first try cookie locally
    this._cachedID = getCookie(LIVERAMP_CACHE_KEY);
    if (this._cachedID.length) {
      return this._cachedID;
    }

    // send request to server now
    this._getEnvelope();
    return this._cachedID;
  }

  getID(): string {
    // equivalent to getID. But used by ats polyfill
    this._refreshID();
    return this._cachedID;
  }
}
const liverampidp: _liverampidp = new _liverampidp(IDP_LIVERAMP);

export default liverampidp;
